var _defs, _rect, _path, _path2, _rect2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 351.4,
    y: 546.2,
    width: 288.6,
    height: 63.9,
    rx: 16,
    ry: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.6,610.1h-32c-8.8,0-16-7.2-16-16v-32c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v32c.5,8.4-6,15.5-14.4,16-.5,0-1.1,0-1.6,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.6,467.3h-32c-8.8,0-16-7.2-16-16v-32c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v32c.5,8.4-6,15.5-14.4,16-.5,0-1.1,0-1.6,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 351.4,
    y: 403.4,
    width: 288.6,
    height: 63.9,
    rx: 16,
    ry: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 399.4,
    y: 260.6,
    width: 240.6,
    height: 63.9,
    rx: 16,
    ry: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.4,210.6l-17-17c-4.3-4.7-11.6-5-16.3-.7-.2.2-.5.4-.7.7l-105.8,104.9-43-41.9c-4.3-4.7-11.6-5-16.3-.7-.2.2-.5.4-.7.7l-17,17c-4.7,4.3-5,11.6-.7,16.3.2.2.4.5.7.7l58.9,58.9c9.4,9.4,24.5,9.4,33.9,0l123.8-121.8c4-5,4-12.1,0-17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default-icon.14a8874503423501328559e5d62c0ecc.svg";
export { ForwardRef as ReactComponent };